const NotificationTypes = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error"
} as const;

const ALL = Object.values(NotificationTypes);

export default { ...NotificationTypes, ALL };
